import { TeamDataObject } from "../DataStorage/TeamDataObject";
import { BuilderTypes } from "./BuilderTypes";
import { BuilderStorageConstants } from "./BuilderStorageConstants";
import { ValidationIssue } from "../../Common/IDesignValidationProvider";

export class BuilderStorageItem extends TeamDataObject {
    // since the same builder data might exist in multiple teams, we need to use this alternate id
    // as the ID for the builders instead of the database id.
    builderId: string;
    name: string;
    builderType: BuilderTypes;
    projectId?: string;
    majorVersion: number = 0;
    minorVersion: number = 0;
    revision: number = 0;
    tags: string[] = [];
    // this field is used for rule sets or types that are used in other types like unit tests.
    parentId?: string;
    changeSetName: string = BuilderStorageConstants.LIVE_CHANGE_SET_NAME;
    validationBreaks: ValidationIssue[] = [];
    isNewInChangeSet: boolean = true;
    mergedToLiveBranch: boolean = false;

    constructor(builderId: string, builderType: BuilderTypes, name: string) {
        super();
        this.builderId = builderId;
        this.name = name;
        this.builderType = builderType;
    }
}
